import { mergeClasses, Link, Text } from "@fluentui/react-components";
import { useStyles } from "./poweredByFooter.styles";

export const PoweredByFooter = ({
  className,
}: {
  className?: string;
}): JSX.Element => {
  const styles = useStyles();
  return (
    <div className={mergeClasses(styles.root, className)}>
      <Text className={styles.text}>
        This interview is powered by The North Highland Company.{" "}
        <Link
          href="https://www.northhighland.com"
          target="_blank"
          rel="noopener noreferrer"
          appearance="subtle"
          className={styles.link}
        >
          Click here
        </Link>{" "}
        to learn more about North Highland.
      </Text>
    </div>
  );
};
